export const BREAK_LINE_CHARACTER = '<br />';

export function addNewLineBeforeMatches(text: string, searchStrings: string[]): string {
  return searchStrings.reduce(
    (result, searchString) => result.split(searchString).join(BREAK_LINE_CHARACTER + searchString),
    text
  );
}
